/**
 * Social Sharing
 */

const socialSharing = () => {
  const windowLocation = window.location.href.replace(window.location.hash, '');
  const titlePage = () => {
    const titleItem = document.querySelector('.r-title__primary h1');
    let titleE;

    if (titleItem !== null) {
      titleE = encodeURIComponent(titleItem.textContent);
    } else {
      titleE = encodeURIComponent(document.querySelector('h1').textContent);
    }

    return titleE;
  };

  const facebookShare = () => {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + windowLocation,
      'facebookWindow',
      'height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0'
    );
    return false;
  };

  const twitterShare = () => {
    console.log(titlePage());
    window.open(
      'http://twitter.com/intent/tweet?text=' + titlePage() + ' ' + windowLocation,
      'twitterWindow',
      'height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0'
    );
    return false;
  };

  const linkedinShare = () => {
    window.open(
      'http://www.linkedin.com/shareArticle?mini=true&url=' + windowLocation + '&title=' + titlePage() + '',
      'linkedInWindow',
      'height=480,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0'
    );
    return false;
  };

  const whatsappShare = () => {
    window.open(
      'https://wa.me/?text=' + windowLocation,
      'whatsappWindow',
      'height=640,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0'
    );
    return false;
  };

  const printShare = () => {
    window.print();
  };

  if (document.querySelector('.share-social') !== null) {
    document.querySelector('.share-social .wp-social-link-facebook a').addEventListener('click', (e) => {
      e.preventDefault();
      facebookShare();
    });
    document.querySelector('.share-social .wp-social-link-twitter a').addEventListener('click', (e) => {
      e.preventDefault();
      twitterShare();
    });
    document.querySelector('.share-social .wp-social-link-linkedin a').addEventListener('click', (e) => {
      e.preventDefault();
      linkedinShare();
    });
    document.querySelector('.share-social .wp-social-link-print a').addEventListener('click', (e) => {
      e.preventDefault();
      printShare();
    });
  };

};

export { socialSharing };
